// extracted by mini-css-extract-plugin
export var cardLayout = "_75-1";
export var paginationContainer = "_75-0";